import { format, parseISO } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

/**
 * return year-month-day string
 * @function getISODate
 * @param {string} date - date string
 * @returns {string} - date string YYYY-mm-dd
 */
export function getISODate(date) {
  const eventDate = new Date(date);
  return `${eventDate.getFullYear()}-${String(eventDate.getMonth() + 1).padStart(2, '0')}-${String(eventDate.getDate()).padStart(2, '0')}`;
}

/**
 * organizes events by time
 * @function organizeByTime
 * @param {Object[]} data - data to be organized by time
 * @return {Object[]} - oarray of objects with time keys with array of events
 */
const organizeByTime = (data) => {
  const fmt = 'h:mmaaa';
  const eventsByTime = {};
  for (const event of data) {
    let eventDate = new Date(event.local_iso8601);
    // key time in seconds so when we sort by keys it should be in correct order
    if (eventsByTime[eventDate]) {
      eventsByTime[eventDate].push(event);
    } else {
      eventsByTime[eventDate] = [event];
    }
  }
  return eventsByTime
}

/**
 * organizes events by date
 * @function organizeByDate
 * @param {Object[]} data - data to be organized by dates
 * @param {Object} eventsByDate - event object to add sorted events to
 * @return {Object[]} - and Object with keys of dates and array of events
 */
const organizeByDate = (data) => {
  const fmt = 'yyyy-MM-dd';
  const eventsByDate = {};
  for (const event of data) {
    const parsedTime = parseISO(event.local_iso8601);
    const dateKey = event.tzid ? formatInTimeZone(parsedTime, event.tzid, fmt) : format(parsedTime, fmt);
    if (eventsByDate[dateKey]) {
      eventsByDate[dateKey].push(event);
    } else {
      eventsByDate[dateKey] = [event];
    }
  }
  return eventsByDate;
}

/**
 * returns Object of events organized by date
 * @param {Object} data
 * @returns {Object}
 */
const parseCalJSON = data => {
  const eventsByDate = organizeByDate(data);
  for (const dateKey of Object.keys(eventsByDate)) {
    eventsByDate[dateKey] = organizeByTime(eventsByDate[dateKey])
  }
  return eventsByDate;
}


export default parseCalJSON;